"use strict";

exports.__esModule = true;
exports.default = void 0;

/**
 * Returns empty attributed string
 *
 * @return {Object} empty attributed string
 */
var empty = function empty() {
  return {
    string: '',
    runs: []
  };
};

var _default = empty;
exports.default = _default;